export default "__VITE_ASSET__DFK6LGC1__"